import { Center } from '@/types/models'

export const getExistingQualityScore = (center: Center): number => {
  if (!center.quality_score) {
    return center?.qualityScore || 0
  }
  return center.quality_score
}
